import { Col, Container, Row } from 'react-bootstrap';
import React, { ChangeEvent, useEffect, useState } from "react";
import DefaultCard from '../../components/DefaultCard';
import GenericCard from '../../components/GenericCards/GenericCards';
import CustomSelect from '../../components/Select';
import YTD from '../../components/AccountHistoryRanges/YTD';
import TM from '../../components/AccountHistoryRanges/TM';

import {
  addOrRemoveDaysToGivenDate,
  DateFormats,
  formatDate,
} from '../../utils/utils';

function Apps() {

const [yearToDate, twelveMonth] = useState("selectHistory");

const [ytdContentVisible, setYTDContentVisible] = useState(false);
  const [tmContentVisible, setTMContentVisible] = useState(false);


  useEffect(() => {
    yearToDate === "ytd"
      ? setYTDContentVisible(true)
      : setYTDContentVisible(false);
    yearToDate === "tm" ? setTMContentVisible(true) : setTMContentVisible(false);
  }, [yearToDate]);

   const handleOnChange = (e: ChangeEvent<HTMLSelectElement>) => {
    twelveMonth(e.target.value);
  };

  <select className="form-select" value={yearToDate} onChange={handleOnChange}>
          <option value="selectHistory">Select date range</option>
          <option value="ytd">ytd</option>
          <option value="tm">tm</option>
        </select>

      {ytdContentVisible && <YTD />}
      {tmContentVisible && <TM />}
 
}


const optionsPlans = [{ value: '1', label: 'Cash Balance Plan' }];

const optionsAsOf = [
    { value: '1', label: 'Last Recordkeeping Cycle' },
    { value: 'ytd', label: 'Year to Date' },
    { value: 'tm', label: 'Last 12 Months' },
    { value: '4', label: 'Custom' }
];





const transactionDateRange = [
  {
    transactionType: 'Year to Date',
    startingBalance: '$47,001.77',
    payCredits: '$5,741.78',
    interestCredits: '$1,849.07',
    endingBalance: '$54,592.62',
  },

];

const transactionTableData = [
  {
    requestedDate: '09/01/2022',
    payCredits: '$0.00',
    adjustments: '..',
    interestCredits: '$63.42',
    transactionType: 'Hardship Withdrawal',
    endingBalance: '$107,562.39',
  },

  {
    requestedDate: formatDate(
      addOrRemoveDaysToGivenDate(new Date(), -2),
      DateFormats.US
    ),
    payCredits: '$0.00',
    adjustments: '..',
    interestCredits: '$63.42',
    transactionType: 'Change Contributions',
    endingBalance: '$107,562.39',
  },

  {
    requestedDate: formatDate(
      addOrRemoveDaysToGivenDate(new Date(), -365),
      DateFormats.US
    ),
    payCredits: '$0.00',
    adjustments: '..',
    interestCredits: '$63.42',
    transactionType: 'Pension Election',
    endingBalance: '$107,562.39',
  },

  {
    requestedDate: formatDate(
      addOrRemoveDaysToGivenDate(new Date(), -730),
      DateFormats.US
    ),
    payCredits: '$0.00',
    adjustments: '..',
    interestCredits: '$63.42',
    transactionType: 'Contribution Change',
    endingBalance: '$107,562.39',
  },

  {
    requestedDate: '03/17/2022',
    payCredits: '$0.00',
    adjustments: '..',
    interestCredits: '$63.42',
    transactionType: 'Rebalance Funds',
    endingBalance: '$107,562.39',
  },

  {
    requestedDate: '03/17/2022',
    payCredits: '$0.00',
    adjustments: '..',
    interestCredits: '$63.42',
    transactionType: 'Remove Direct Deposit',
    endingBalance: '$107,562.39',
  },

  {
    requestedDate: '03/17/2022',
    payCredits: '$0.00',
    adjustments: '..',
    interestCredits: '$63.42',
    transactionType: 'Investment Direction',
    endingBalance: '$107,562.39',
  },

  {
    requestedDate: '03/17/2022',
    payCredits: '$0.00',
    adjustments: '..',
    interestCredits: '$63.42',
    transactionType: 'Home Loan',
    endingBalance: '$107,562.39',
  },

  {
    requestedDate: '03/17/2022',
    payCredits: '$0.00',
    adjustments: '..',
    interestCredits: '$63.42',
    transactionType: 'Withdrawal',
    endingBalance: '$107,562.39',
  },

  {
    requestedDate: '03/17/2022',
    payCredits: '$0.00',
    adjustments: '..',
    interestCredits: '$63.42',
    transactionType: 'Pension Direct Deposit',
    endingBalance: '$107,562.39',
  },

  {
    requestedDate: '03/17/2022',
    payCredits: '$0.00',
    adjustments: '..',
    interestCredits: '$63.42',
    transactionType: 'Withdrawal Rollover',
    endingBalance: '$107,562.39',
  },
];

const today = new Date();

const currentYear = new Date().getFullYear();

const startDate = new Date(currentYear, 0, 1);

const endDate = new Date(today.getFullYear(), today.getMonth(), 0);

const formattedStartDate = formatDate(
  startDate,
  DateFormats.SHORT_MONTH_DAY_YEAR
);
const formattedStartDateUS = formatDate(startDate, DateFormats.US);
const formattedEndDate = formatDate(endDate, DateFormats.SHORT_MONTH_DAY_YEAR);
const formattedEndDateUS = formatDate(endDate, DateFormats.US);

const AccountActivity = () => {
  return (
    <Container className={'cnd-custom-container mt-11 mb-3'}>
      <Row className={'align-items-center'}>
        <Col className={'col-12 col-lg-4 mb-10 mb-lg-0'}>
          <h2 className={'text-sm-20-lg-32'}>Account History</h2>
          <span className={'text-fs-6 text-light-grey fw-light'}>
            {formattedStartDate} - {formattedEndDate}
          </span>
        </Col>
        <Col className={'col-12 col-lg-4 mb-7 mb-lg-0'}>
          <CustomSelect
            options={optionsPlans}
            placeholder={'Cash Balance Plan'}
          />
        </Col>
        <Col className={'col-12 col-lg-4 mb-7 mb-lg-0'}>
          <CustomSelect options={optionsAsOf} placeholder={'Year to Date'} />
          
        </Col>
      </Row>
      {transactionDateRange.map((transaction, index) => {
                  return (
      <Row className={'mt-13'}>
      
        <Col>
          <GenericCard className={'px-10 py-lg-10'} variant={'white'}>
            <Row className={'align-items-center px-5 py-10'}>
              <Col
                className={'d-flex flex-column col-12 col-lg-3 ms-10 ms-lg-0'}
              >
                <span className={'fw-light text-fs-6 mb-3 text-ligther-grey'}>
                  Starting Balance - {formattedStartDateUS}
                </span>
                <span className={'text-sm-24-lg-32'}>{transaction.startingBalance}</span>
              </Col>
              <Col
                className={
                  'd-flex flex-column align-items-lg-center col-12 col-lg-3 mt-13 mt-lg-0 ms-10 ms-lg-0'
                }
              >
                <span className={'fw-light text-fs-6 mb-3 text-ligther-grey'}>
                  Pay Credits & Adjustments
                </span>
                <span className={'text-sm-24-lg-32'}>{transaction.payCredits}</span>
              </Col>
              <Col
                className={
                  'd-flex flex-column align-items-lg-center col-12 col-lg-2 mt-13 mt-lg-0 ms-10 ms-lg-0'
                }
              >
                <span className={'fw-light text-fs-6 mb-3 text-ligther-grey'}>
                  Interest Credits
                </span>
                <span className={'text-sm-24-lg-32'}>{transaction.interestCredits}</span>
              </Col>
              <Col className={'col-12 col-lg-3 ms-auto mt-11 mt-lg-0'}>
                <DefaultCard
                  className={'py-7 px-10'}
                  leftSubheading={
                    <Row>
                      <Col className={'col-12 text-lg-end mb-3 ps-0'}>
                        <span className={'text-white'}>
                          Ending Balance - {formattedEndDateUS}
                        </span>
                      </Col>
                      <Col className={'col-12 text-lg-end ps-0'}>
                        <span className={'text-sm-24-lg-32'}>{transaction.endingBalance}</span>
                      </Col>
                    </Row>
                  }
                  variant={'blue'}
                />
              </Col>
            </Row>
            
          </GenericCard>
        </Col>

        
      </Row>
      );
                })}


      {/*
      <Row className={'mt-10 mt-lg-0'}>
        <Col className={'col-12'}>
          <GenericCard variant={'gray'}>
            <Row className={'my-11'}>
              <Col>
                <span className={'text-sm-20-lg-24'}>Details</span>
              </Col>
            </Row>

            <Row>
              <Col className={'d-flex flex-column d-lg-block flex-nowrap'}>
                <Row
                  className={
                    'flex-nowrap px-8 px-lg-0 d-flex align-items-center border-bottom-dark-gray py-8'
                  }
                  style={{ minWidth: '650px' }}
                >
                  <Col className={'col-2 col-lg-4 text-fs-6 m-0'}>
                    Start Date
                  </Col>
                  <Col className={'col-2 ps-6 m-0 text-end'}>
                    <span className={'text-fs-6'}>Pay Credits</span>
                  </Col>
                  <Col className={'col-2 text-fs-6 m-0 text-end'}>
                    <span className={'text-fs-6'}>Adjustments</span>
                  </Col>
                  <Col className={'col-3 col-lg-2 text-fs-6 m-0 text-end'}>
                    <span className={'text-fs-6'}>Interest Credits</span>
                  </Col>
                  <Col className={'col-3 col-lg-2 text-fs-6 m-0 text-end'}>
                    <span className={'text-fs-6'}>Ending Balance</span>
                  </Col>
                </Row>
                {transactionTableData.map((transaction, index) => {
                  return (
                    <Row
                      className={
                        'flex-nowrap px-8 py-11 px-lg-0 py-lg-8 d-flex flex-lg-row align-items-center border-bottom border-info'
                      }
                      key={index}
                      style={{ minWidth: '650px' }}
                    >
                      <Col className={'col-2 col-lg-4'}>
                        <span className={'h3 text-fs-6 m-0'}>
                          {transaction.requestedDate}
                        </span>
                      </Col>
                      <Col className={'col-2 text-end'}>
                        <span className={'h3 text-fs-6'}>
                          {transaction.payCredits}
                        </span>
                      </Col>
                      <Col className={'col-2 text-end'}>
                        <span className={''}>{transaction.adjustments}</span>
                      </Col>
                      <Col className={'col-3 col-lg-2 text-end'}>
                        <span className={'fw-light text-fs-6'}>
                          {transaction.interestCredits}
                        </span>
                      </Col>
                      <Col className={'col-3 col-lg-2 text-end'}>
                        <span
                          className={
                            'w-100 text-end text-lg-start h3 text-fs-6 m-0'
                          }
                        >
                          {transaction.endingBalance}
                        </span>
                      </Col>
                    </Row>
                  );
                })}
              </Col>
            </Row>
          </GenericCard>
        </Col>
      </Row>
      */}

      
                
    </Container>
  );
};

export default AccountActivity;
